import { Box, Button, Modal, Text } from "@modernatx/ui-kit-react-v2";
import React from "react";

import { AgePopupProps } from "@/components/V2/Block";
import { useFinder } from "@/finder/hooks/useFinderV2";
import { getValidAgeString } from "@/finder/utils";

export const AgePopup: React.FC<AgePopupProps> = ({
  bodyText,
  buttonText,
  headerText,
  inputLabel
}) => {
  const [popupAge, popupAgeSet] = React.useState<string>("");

  const { ageSet: finderAgeSet, couldSearchExceptForAge } = useFinder();

  const handleSubmit = () => {
    const parsedAge = parseInt(popupAge, 10);
    if (!isNaN(parsedAge)) {
      finderAgeSet(parsedAge);
    }
  };

  const handleAgeInptutChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const validAgeString = getValidAgeString(event.target.value);
    popupAgeSet(validAgeString);
  };

  return (
    <Modal isOpen={couldSearchExceptForAge} size="xs">
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: "spacing-7",
          padding: "spacing-7"
        }}
      >
        <Text
          size="font-size-8"
          weight="light"
          lineHeight="leading-1"
          letterSpacing="kerning-2"
          sx={{ fontVariantNumeric: "lining-nums tabular-nums", color: "text-link" }}
        >
          {headerText}
        </Text>
        <Text
          color="black" // todo: update color from theme
          size="font-size-4"
          lineHeight="leading-2"
          sx={{ fontVariantNumeric: "lining-nums tabular-nums" }}
        >
          {bodyText}
        </Text>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}
        >
          <Box
            sx={{ display: "flex", gap: "spacing-3", alignItems: "center", height: "spacing-10" }}
          >
            <Box
              id="text-field-wrapper"
              sx={{
                width: "spacing-14",
                alignSelf: "stretch",
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "color-system-gray-300",
                borderRadius: "radius-1"
              }}
            >
              <Box
                as="input"
                sx={{ maxWidth: "100%", height: "100%", py: 2, px: 3 }}
                id="text-field"
                value={popupAge}
                onChange={handleAgeInptutChange}
              />
            </Box>
            <Text
              sx={{ fontSize: "font-size-5", letterSpacing: "kerning-1", lineHeight: "leading-2" }}
            >
              {inputLabel}
            </Text>
          </Box>
          <Button
            icon="arrow-right"
            iconPosition="end"
            size="large"
            disabled={!popupAge}
            sx={{ height: "100%" }}
            onClick={handleSubmit}
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
